import { DimTree } from '@/common/entityFramework/entityPerspective/support/DimTree';
import { ContentBox } from '@/common/layout/MainBox';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { DemFinanceDashboardBsView } from './views/DemFinanceDashboardBsView';
import { DemFinanceDashboardPlView } from './views/DemFinanceDashboardPlView';

export const DemFinanceDashboard = () => {

  const rsrc = useRsrc();

  const periodicityToPeriodCodes = useRef();

  const [periods, setPeriods] = useState();
  const [prodTree, setProdTree] = useState();
  const [channelTree, setChannelTree] = useState();


  const views = ['P/L', 'Balance Sheet']

  const viewToComponent = {
    'P/L': DemFinanceDashboardPlView,
    'Balance Sheet': DemFinanceDashboardBsView
  }

  const [view, setView] = useState('Balance Sheet');

  const [startPeriod, setStartPeriod] = useState();
  const [endPeriod, setEndPeriod] = useState();
  const [periodicity, setPeriodicity] = useState('MON');
  const [prodIds, setProdIds] = useState();
  const [channelIds, setChannelIds] = useState();

  useEffect(() => {

    rsrc.data('gtn', 'FINANCE_DASHBOARD_FILTERS_DATA_PLUGIN').then(res => {
      periodicityToPeriodCodes.current = res.periodicityToPeriodCodes;
      handlePeriodicityChange(periodicity);

      setProdTree(res.prodTree);
      const prodIds = TreeUtils.parseTree(res.prodTree).leafIds;
      setProdIds(prodIds);

      setChannelTree(res.channelTree);
      const channelIds = TreeUtils.parseTree(res.channelTree).leafIds;
      setChannelIds(channelIds);
    });

  }, [])

  const handlePeriodicityChange = (periodicity) => {
    setPeriodicity(periodicity);
    const periods = periodicityToPeriodCodes.current[periodicity];
    setPeriods(periods);

    const startPeriod = periods[0];
    const endPeriod = periods[periods.length - 3];
    setStartPeriod(startPeriod);
    setEndPeriod(endPeriod);
  };


  if (!prodIds) return;

  const ViewComponent = viewToComponent[view];

  return (
    <ContentBox>


      <Title
        icon={fas.faChartLine}
        title="Finance Dashboard"
        buttons={
          <FormControl fullWidth sx={{ minWidth: 200 }}>
            <InputLabel>View</InputLabel>
            <Select value={view} onChange={event => setView(event.target.value)}>
              {views.map(view => <MenuItem key={view} value={view}>{view}</MenuItem>)}
            </Select>
          </FormControl>
        }
      />

      {/* Filters */}
      <Box sx={{ display: 'flex', gap: 2 }}>

        <TextField fullWidth select variant="outlined" label="Start Period" value={startPeriod} onChange={event => setStartPeriod(event.target.value)}>
          {periods.map(periodValue => (
            <MenuItem key={periodValue} value={periodValue}>
              {periodValue}
            </MenuItem>
          ))}
        </TextField>

        <TextField fullWidth select variant="outlined" label="End Period" value={endPeriod} onChange={event => setEndPeriod(event.target.value)}>
          {periods.map(periodValue => (
            <MenuItem key={periodValue} value={periodValue}>
              {periodValue}
            </MenuItem>
          ))}
        </TextField>

        <TextField fullWidth select variant="outlined" label="Periodicity" value={periodicity} onChange={event => handlePeriodicityChange(event.target.value)} >
          <MenuItem value="MON">Month</MenuItem>
          <MenuItem value="QTR">Quarter</MenuItem>
          <MenuItem value="YEAR">Year</MenuItem>
        </TextField>

        <DimTree
          displayName="Channel"
          treeData={channelTree}
          selectedIds={channelIds}
          onFilterChange={ids => setChannelIds(ids)}
        />
        <DimTree
          displayName="Product"
          treeData={prodTree}
          selectedIds={prodIds}
          onFilterChange={ids => setProdIds(ids)}
        />
      </Box>

      {/* Graphs */}
      <ViewComponent startPeriod={startPeriod} endPeriod={endPeriod} periodicity={periodicity} prodIds={prodIds} channelIds={channelIds} periods={periods} channelTree={channelTree} />
    </ContentBox>
  )
}